/**
 * Vietnamese language pack
 * Generated by translate.js - DO NOT EDIT MANUALLY
 * Source: zh → vi
 */

export default {
  app: {
    logo: 'TikiBox',
    login: 'Đăng nhập vào / đăng nhập vào',
    register: 'Đăng ký / Đăng ký',
    logout: 'Đăng nhập ra ngoài',
    confirmLogout: 'Bạn có chắc chắn muốn đăng nhập không?',
    cancel: 'Hủy bỏ đi',
    confirm: '- Chắc chắn rồi',
    welcome: 'Chào mừng bạn đến',
    myOrders: 'đơn đặt hàng của ta',
    myFavorites: 'bộ sưu tập của ta',
    shoppingCart: 'Giỏ hàng mua sắm / Giỏ hàng mua sắm',
    home: 'Trang chủ / Trang chủ / Trang chủ',
    allGoods: 'Tất cả hàng hóa',
    luckyWheel: 'Bánh xe may mắn',
    aboutUs: 'Về chúng tôi',
    search: 'Vui lòng nhập nội dung tìm kiếm',
    footer: {
      sevenDayReturn: '7 ngày không có lý do để đổi hàng',
      freeShipping: '99 USD miễn phí bưu điện',
      qualityAssurance: '100% đảm bảo chất lượng',
      copyright: 'Bản quyền của Trung tâm Thương mại © 2012-2026',
      slogan: 'Kho số gần bạn với giá tốt và chất lượng',
      aboutColumnTitle: 'Về TikiBox',
      privacy: 'Quyền riêng tư',
      serviceRefund: 'Hoàn tiền dịch vụ',
      infoTitle: 'Thông tin',
      refundReturnPolicy: 'Chính sách hoàn tiền và trả hàng',
      logisticsPolicy: 'Chính sách logistics',
      contactUs: 'Liên hệ',
      socialFacebook: 'Facebook',
      socialYoutube: 'YouTube'
    }
  },
  category: {
    phone: 'điện thoại di động',
    appliance: 'Thiết bị gia dụng',
    accessory: 'Phụ kiện / phụ kiện',
    hot: 'người hâm mộ lựa chọn:',
    tvAudio: 'truyền hình, hình ảnh, âm thanh',
    protectiveCover: 'vỏ bọc bảo vệ / vỏ bọc bảo vệ',
    charger: 'bộ sạc điện / bộ sạc điện'
  },
  login: {
    title: 'Đăng nhập vào / đăng nhập vào',
    username: 'Vui lòng nhập số tài khoản',
    password: 'Vui lòng nhập mật khẩu',
    button: 'Đăng nhập vào / đăng nhập vào',
    usernameRule: 'Vui lòng nhập tên người dùng',
    usernameRuleError: 'Bắt đầu từ chữ cái, chiều dài từ 5 đến 16, cho phép gạch dưới chữ số',
    passwordRule: 'Vui lòng nhập mật khẩu',
    passwordRuleError: 'Bắt đầu từ chữ cái, chiều dài từ 6-18 cho phép chữ số và gạch gạch dưới',
    success: 'Đăng nhập thành công',
    failed: 'Không thể đăng nhập',
    agreeRequired: 'Vui lòng đọc và đồng ý Điều khoản dịch vụ và Chính sách quyền riêng tư',
    agreePrefix: 'Tôi đã đọc và đồng ý',
    agreeAnd: 'và',
    serviceAgreementLink: '《Điều khoản dịch vụ》',
    privacyPolicyLink: '《Chính sách quyền riêng tư》'
  },
  register: {
    title: 'Đăng ký / Đăng ký',
    username: 'Tên người dùng (user name)',
    password: 'mật mã / mật mã / mật mã',
    confirmPassword: 'Xác nhận mật khẩu',
    button: 'Đăng ký / Đăng ký',
    usernamePlaceholder: 'Vui lòng nhập tên người dùng',
    passwordPlaceholder: 'Vui lòng nhập mật khẩu',
    confirmPasswordPlaceholder: 'Vui lòng nhập lại mật khẩu',
    usernameRule: 'Vui lòng nhập tên người dùng',
    usernameRuleError: 'Bắt đầu từ chữ cái, chiều dài từ 5 đến 16, cho phép gạch dưới chữ số',
    passwordRule: 'Vui lòng nhập mật khẩu',
    passwordRuleError: 'Bắt đầu từ chữ cái, chiều dài từ 6-18 cho phép chữ số và gạch gạch dưới',
    confirmRule: 'Mật khẩu hai lần nhập không khớp nhau',
    success: 'đăng ký thành công',
    failed: 'Đăng ký không thành công',
    exists: 'Tên người dùng đã tồn tại'
  },
  goods: {
    all: 'Tất cả hàng hóa',
    sort: 'Sắp xếp thứ tự',
    default: 'mặc định (mặc định)',
    priceAsc: 'giá từ thấp đến cao',
    priceDesc: 'Giá cả từ cao đến thấp',
    salesDesc: 'Số lượng bán hàng từ cao đến thấp',
    noResults: 'Không tìm thấy sản phẩm liên quan',
    addToCart: 'Thêm vào giỏ hàng',
    addSuccess: 'Hàng hóa đã được thêm vào giỏ hàng',
    viewDetails: 'Xem chi tiết'
  },
  details: {
    addToCart: 'Thêm vào giỏ hàng',
    buyNow: 'Mua ngay lập tức',
    productDetails: 'Chi tiết hàng hóa',
    specs: 'tiêu chuẩn kỹ thuật / tiêu chuẩn kỹ thuật',
    selectSpec: 'Vui lòng chọn thông số kỹ thuật',
    stock: 'hàng tồn kho / hàng tồn kho',
    reviews: 'đánh giá hàng hóa',
    noReviews: 'tạm thời không có đánh giá',
    relatedProducts: 'hàng hóa tương tự'
  },
  cart: {
    title: 'Giỏ hàng mua sắm / Giỏ hàng mua sắm',
    empty: 'Giỏ hàng không có gì',
    total: 'Tổng cộng của chúng tôi',
    totalPrice: 'tổng giá / tổng giá',
    goShopping: 'đi mua sắm',
    selected: 'Đã được chọn',
    items: 'món hàng',
    remove: 'Xóa bỏ nó đi',
    clearInvalid: 'Làm sạch hàng hóa hết hạn',
    settle: 'thanh toán / thanh toán / thanh toán',
    allSelected: 'Toàn bộ lựa chọn',
    invalid: 'vô hiệu hóa / vô hiệu hóa',
    lineSubtotal: 'Tạm tính',
    deleteSuccess: 'Xóa thành công',
    deleteFailed: 'Xóa thất bại'
  },
  order: {
    title: 'đơn đặt hàng của ta',
    all: 'Tất cả các đơn đặt hàng',
    pending: 'chờ thanh toán / chờ thanh toán',
    paid: 'đã được thanh toán rồi',
    shipped: 'đang chờ nhận hàng',
    completed: 'Đã hoàn thành rồi',
    cancelled: 'đã bị hủy bỏ',
    noOrders: 'tạm thời không có lệnh',
    orderNumber: 'số đơn đặt hàng / order number',
    orderTime: 'thời gian đặt hàng',
    totalAmount: 'Tổng số tiền',
    status: 'Trạng thái đơn đặt hàng',
    action: 'hoạt động / hoạt động',
    pay: 'thanh toán / thanh toán / thanh toán',
    confirmReceive: 'xác nhận nhận nhận hàng',
    viewDetails: 'Xem chi tiết'
  },
  confirmOrder: {
    title: 'Xác nhận đơn đặt hàng',
    shippingAddress: 'địa chỉ nhận hàng',
    addAddress: 'Thêm địa chỉ mới',
    useDefault: 'Sử dụng địa chỉ mặc định',
    productInfo: 'thông tin về hàng hóa',
    totalAmount: 'Tổng số tiền đặt hàng',
    freight: 'phí vận chuyển',
    total: 'Tổng cộng',
    submitOrder: 'Gửi đơn đặt hàng',
    payNow: 'thanh toán ngay lập tức',
    orderSuccess: 'Đơn đặt hàng đã được gửi thành công',
    orderFailed: 'Gửi đơn đặt hàng không thành công',
    invoice: 'thông tin hóa đơn',
    electronicInvoice: 'hóa đơn điện tử',
    personal: 'cá nhân'
  },
  collect: {
    title: 'bộ sưu tập của ta',
    empty: 'Chưa có sưu tầm hàng hóa',
    goShopping: 'đi dạo một chút',
    removeCollect: 'Hủy bỏ bộ sưu tập',
    removeSuccess: 'Bộ sưu tập đã bị hủy bỏ'
  },
  about: {
    title: 'Về chúng tôi',
    description: 'TikiBox là một trung tâm mua sắm trực tuyến tập trung vào việc cung cấp cho bạn hàng hóa chất lượng. Chúng tôi cam kết cung cấp cho người dùng trải nghiệm mua sắm an toàn, thuận tiện và chất lượng.'
  },
  policy: {
    returnTitle: 'Chính sách Đổi Trả',
    returnSubtitle: 'Điều kiện đổi trả',
    returnItem1: 'Trong vòng 7 ngày kể từ khi nhận hàng, nếu sản phẩm còn nguyên vẹn và không ảnh hưởng đến việc bán lại, bạn có thể xin đổi trả không vì lý do.',
    returnItem2: 'Đối với các vấn đề về chất lượng (như hư hỏng, lỗi chức năng, v.v.), bạn có thể xin đổi trả, phí vận chuyển do người bán chịu.',
    returnItem3: 'Đơn xin đổi/trả phải được gửi trên trang chi tiết đơn hàng. Tiền hoàn sẽ được hoàn trả trong vòng 3-5 ngày làm việc sau khi nhận được hàng.',
    returnItem4: 'Các trường hợp sau không thuộc phạm vi đổi trả: Hư hỏng do con người gây ra, sản phẩm làm theo yêu cầu, hư hỏng do nguyên nhân cá nhân.',
    returnProcess: 'Quy trình đổi trả',
    returnProcessDesc: 'Gửi yêu cầu → Người bán xét duyệt → Gửi lại hàng → Người bán nhận hàng → Hoàn tiền/Đổi hàng',
    shippingTitle: 'Chính sách logistics',
    shippingSubtitle: 'Thông tin vận chuyển',
    shippingItem1: 'Đơn hàng từ 99 đô trở lên được miễn phí vận chuyển.',
    shippingItem2: 'Đơn hàng dưới 99 đô sẽ chịu phí vận chuyển tương ứng, phí cụ thể được hiển thị tại trang thanh toán.',
    shippingItem3: 'Chúng tôi giao hàng đến hầu hết các khu vực trên toàn quốc. Các khu vực xa có thể cần thời gian giao hàng lâu hơn.',
    shippingTime: 'Thời gian giao hàng',
    shippingTimeDesc: 'Trong điều kiện bình thường, đơn hàng sẽ được gửi đi trong 1-3 ngày làm việc và giao hàng trong 3-7 ngày làm việc. Thời gian giao hàng thực tế phụ thuộc vào địa chỉ giao hàng và tình trạng logistics.',
    qualityTitle: 'Bảo đảm Chất lượng',
    qualitySubtitle: 'Cam kết chất lượng',
    qualityItem1: 'Tất cả sản phẩm đều là hàng chính hãng và đã qua kiểm tra chất lượng nghiêm ngặt.',
    qualityItem2: 'Mô tả sản phẩm chính xác và trung thực, giá cả minh bạch, không có phí ẩn.',
    qualityItem3: 'Chúng tôi cung cấp dịch vụ sau bán hàng toàn diện với đội ngũ chăm sóc khách hàng chuyên nghiệp.',
    qualityItem4: 'Nếu bạn có bất kỳ thắc mắc nào về chất lượng sản phẩm, hãy liên hệ với đội ngũ chăm sóc khách hàng của chúng tôi.',
    qualityService: 'Dịch vụ chất lượng',
    qualityServiceDesc: 'Chúng tôi cam kết cung cấp cho bạn các sản phẩm và dịch vụ chất lượng cao. Nếu bạn gặp bất kỳ vấn đề nào trong quá trình mua sắm, xin vui lòng liên hệ với đội ngũ chăm sóc khách hàng của chúng tôi.',
    privacyTitle: 'Chính sách quyền riêng tư',
    privacyItem1: 'Chúng tôi chỉ thu thập thông tin cần thiết để hoàn thành đơn hàng và cải thiện dịch vụ.',
    privacyItem2: 'Thông tin cá nhân của bạn được bảo vệ theo pháp luật và không bán cho bên thứ ba.',
    privacyItem3: 'Bạn có thể xem hoặc cập nhật hồ sơ trong cài đặt tài khoản.',
    serviceAgreementTitle: 'Điều khoản dịch vụ',
    serviceAgreementItem1: 'Sử dụng cửa hàng này đồng nghĩa bạn đồng ý các điều khoản và quy tắc liên quan.',
    serviceAgreementItem2: 'Vui lòng cung cấp thông tin tài khoản chính xác; bạn chịu trách nhiệm về hoạt động dưới tài khoản.',
    serviceAgreementItem3: 'Cửa hàng có thể cập nhật điều khoản khi cần; thay đổi sẽ được công bố trên website.',
    serviceRefundTitle: 'Hoàn tiền dịch vụ',
    serviceRefundItem1: 'Đơn hàng đủ điều kiện sẽ được hoàn tiền theo phương thức thanh toán ban đầu.',
    serviceRefundItem2: 'Thời gian xử lý hoàn tiền thường là 3–7 ngày làm việc.',
    serviceRefundItem3: 'Liên hệ hỗ trợ nếu cần trợ giúp.'
  },
  error: {
    title: 'Có chuyện sai rồi',
    message: 'Xin lỗi, đã xảy ra lỗi trên trang',
    goHome: 'Trở lại trang chủ',
    retry: 'Hãy thử lại'
  },
  common: {
    loading: 'Đang tải...',
    noMore: 'Không còn gì nữa',
    success: 'Hành động thành công',
    failed: 'Hành động không thành công',
    error: 'Lỗi',
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    delete: 'Xóa bỏ nó đi',
    edit: 'Sửa đổi (edit)',
    save: 'Lưu lại (Lưu lại)',
    close: 'Đóng cửa đi',
    back: 'Trở lại đây! Trở lại đây',
    next: 'Bước tiếp theo',
    submit: 'Gửi đi! Gửi đi',
    price: 'giá cả / giá cả',
    quantity: 'số lượng của chúng ta',
    unit: 'mảnh / mảnh / mảnh / mảnh'
  },
  lang: {
    currentLang: 'Ngôn ngữ',
    switchToEn: 'Tiếng Anh',
    switchToZh: 'Tiếng Trung Quốc',
    switchToVi: 'Tiếng Việt'
  },
  luckyWheel: {
    title: 'Bánh xe may mắn',
    start: 'Bắt đầu',
    startLottery: 'Bốc thăm trúng thưởng',
    lotteryUsed: 'Đã bốc thăm hôm nay',
    lotteryHint: 'Mỗi người dùng chỉ được bốc thăm một lần mỗi ngày',
    lotteryUsedHint: 'Bạn đã bốc thăm hôm nay, hãy quay lại vào ngày mai',
    confirmLottery: 'Bạn có chắc chắn muốn chi 50.000 đồng để bốc thăm không?',
    confirmTitle: 'Xác nhận bốc thăm',
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    prizes: 'Danh sách giải thưởng',
    rules: 'Quy tắc',
    prize1: 'iPhone 13',
    prize2: 'AirPods Pro',
    prize3: 'Mi Band',
    prize4: 'Phiếu giảm giá ¥100',
    prize5: 'Phiếu giảm giá ¥50',
    prize6: 'Phiếu giảm giá ¥10',
    congrats: 'Chúc mừng! Bạn đã trúng',
    congratsMessage: 'Vui lòng nhận giải thưởng kịp thời',
    rule1: 'Mỗi người dùng có thể tham gia 1 lần mỗi ngày',
    rule2: 'Vui lòng nhận giải thưởng kịp thời sau khi trúng',
    rule3: 'Phiếu giảm giá có hiệu lực trong 7 ngày',
    rule4: 'TikiBox bảo lưu quyền giải thích cuối cùng'
  }
};